import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TextButtonComponent } from '../button';
import { ButtonIconPosition } from '../button/shared/button-types';
import { SkeletonBlockComponent } from '../skeleton/skeleton-block/skeleton-block.component';

@Component({
  selector: 'xemex-card',
  standalone: true,
  imports: [TextButtonComponent, SkeletonBlockComponent],
  styleUrl: './card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './card.component.html',
  host: { '[class.card-host--fill]': 'fill()' },
})
export class CardComponent {
  title = input.required<string>();
  /** `md` (default) uses the standard card-title token size. `lg` bumps the title to the
   * next token size up — for widgets that need a more prominent title (e.g. dashboard cards). */
  titleSize = input<'md' | 'lg'>('md');
  /** One line of secondary text under the title; cut off with an ellipsis when it does not fit. */
  subtitle = input<string>();
  actionLabel = input<string>();
  actionIcon = input<string>();
  actionIconPosition = input<ButtonIconPosition>('end');
  loading = input<boolean>(false);
  /** Stretches the card to the height of its host, so the cards of one grid row share a height.
   * The host itself must be given that height: a stretched grid or flex item is. */
  fill = input<boolean>(false);
  action = output<void>();
}
